import { Button } from 'components/atoms/Button';
import { Title } from 'components/atoms/Title';
import { SizesEnum } from 'components/atoms/Title/Title.enum';
import useGetCurrentCustomerData from 'hooks/Authentication/useGetCurrentCustomerData';
import type { FC } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { OnboardingCardListType } from 'types/onboarding.types';
import { AvailableCountries } from 'types/users.types';

const OnboardingCardsCarousel: FC<{
  onLast: () => void;
  cards: OnboardingCardListType;
}> = ({ onLast, cards }) => {
  const { data: user } = useGetCurrentCustomerData();
  const { t } = useTranslation();
  const [active, setActive] = useState(0);
  const {
    img,
    title,
    description,
    Description = () => null,
    btnText,
    imgClassName,
  } = cards[active];

  return (
    <div>
      <div className="text-center" key={title}>
        <img alt="" width="100%" className={imgClassName} src={img} />

        <Title type={SizesEnum.h5}>{t(title)}</Title>

        <Description country={user?.country || AvailableCountries.belgium} />

        {description ? (
          <p className="text-lg mt-4 text-primary-800 whitespace-pre-line mb-10">
            {t(description)}
          </p>
        ) : null}

        <Button
          structure={active === cards.length - 1 ? 'primary' : 'secondary'}
          onClick={
            active === cards.length - 1
              ? onLast
              : () => setActive((cardNdx) => cardNdx + 1)
          }
        >
          {t(btnText)}
        </Button>
      </div>
    </div>
  );
};

export default OnboardingCardsCarousel;
